"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DictionaryPattern = void 0;
// MIT © 2017 azu
var PREFIX_BOUNDARY = /(^\/)\\b/;
var POSTFIX_BOUNDARY = /\\b(\/\w*?)$/;
var regexpRegexp = /^\/(.*)\/([gimy]*)$/;
function isRegExpLike(str) {
    return regexpRegexp.test(str);
}
function parseRegExpString(str) {
    var result = str.match(regexpRegexp);
    if (!result) {
        return str;
    }
    return new RegExp(result[1], result[2]);
}
function concat(args, flags) {
    var prevFlags = flags || "";
    var foundRegExp = false;
    var result = args.reduce(function (p, c) {
        if (typeof c === "string") {
            return p + c;
        }
        else if (c instanceof RegExp) {
            c.flags.split("").sort();
            var currentFlags = c.flags
                .split("")
                .sort()
                .join("");
            if (foundRegExp) {
                if (prevFlags !== currentFlags) {
                    throw new Error("combining different flags " + prevFlags + " and " + currentFlags + ".\nThe pattern " + c + " has different flag with other patterns.");
                }
            }
            prevFlags = currentFlags;
            foundRegExp = true;
            return p + c.source;
        }
        else {
            throw new Error("unknown type: " + c);
        }
    }, "");
    return new RegExp(result, prevFlags);
}
function addBoundary(arg) {
    var inputValue = parseRegExpString(arg);
    if (typeof inputValue === "string") {
        return inputValue;
    }
    var wrappedRegExp = concat(["\\b", inputValue.source, "\\b"], inputValue.flags);
    return wrappedRegExp.toString();
}
var DictionaryPattern = /** @class */ (function () {
    function DictionaryPattern(value) {
        this.value = value;
    }
    DictionaryPattern.prototype.addWordBoundary = function () {
        if (this.hasWrappedWordBoundary) {
            return this.value;
        }
        return addBoundary(this.value);
    };
    DictionaryPattern.prototype.trimWorkBoundary = function () {
        if (!this.hasWrappedWordBoundary) {
            return this.value;
        }
        return this.value.replace(PREFIX_BOUNDARY, "$1").replace(POSTFIX_BOUNDARY, "$1");
    };
    Object.defineProperty(DictionaryPattern.prototype, "isRegExpLike", {
        get: function () {
            return isRegExpLike(this.value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DictionaryPattern.prototype, "hasWrappedWordBoundary", {
        /**
         * /\bpattern\b/
         */
        get: function () {
            return PREFIX_BOUNDARY.test(this.value) && POSTFIX_BOUNDARY.test(this.value);
        },
        enumerable: false,
        configurable: true
    });
    DictionaryPattern.prototype.equals = function (pattern) {
        return this.value === pattern.value;
    };
    return DictionaryPattern;
}());
exports.DictionaryPattern = DictionaryPattern;
//# sourceMappingURL=DictionaryPattern.js.map


//////////////////
// WEBPACK FOOTER
// ../domain/lib/Dictionary/DictionaryPattern.js
// module id = 420
// module chunks = 0